// extracted by mini-css-extract-plugin
export default {"container":"base-text-outline-option-module__container--HCoEM","tooltip":"base-text-outline-option-module__tooltip--a2SFe"};